import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import userManager from "../../utils/userManager";

class Icon extends React.Component {

  state = {
    anchorEl: null,
  };

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSignOut = () => {
    userManager.signoutRedirect();
  }
  
  handleManageUser = () => {
    window.location.assign(process.env.REACT_APP_AUTHORITY_URL + '/Manage/ChangePassword');
  }


  render() {
    const { anchorEl } = this.state;
    const { initials } = this.props;
    const open = Boolean(anchorEl);
  
    return (
      <React.Fragment>
        <IconButton
          aria-owns={open ? 'menu-appbar' : null}
          aria-haspopup="true"
          onClick={this.handleMenu}
          color="inherit">
           <Avatar>{initials}</Avatar>
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={this.handleClose}>
          <MenuItem onClick={this.handleManageUser}>Change password</MenuItem>
          <MenuItem onClick={this.handleSignOut}>Logout</MenuItem>
        </Menu>
      </React.Fragment>
    );
  };

}




export default Icon;


// WEBPACK FOOTER //
// ./src/components/Header/Icon.js